/**
 * Decodifica el payload de un JWT (base64url → JSON).
 * No valida la firma (eso lo hace el backend).
 */
function decodeJwtPayload(token) {
  try {
    const base64Url = token.split(".")[1]
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/")
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    )
    return JSON.parse(jsonPayload)
  } catch {
    return null
  }
}

/**
 * Verifica si la sesión del usuario es válida.
 * 
 * Estrategia: si existe un refreshToken, la sesión es válida.
 * El interceptor de axiosClient se encarga de refrescar el accessToken
 * automáticamente cuando expira (401 → POST /auth/refresh).
 * 
 * Solo forzamos logout si NO hay refreshToken (sesión completamente inválida).
 */
export function isTokenValid() {
  try {
    const authData = JSON.parse(localStorage.getItem("authUser"))
    if (!authData?.accessToken) return false

    // Si hay refreshToken, la sesión puede renovarse automáticamente
    if (authData.refreshToken) return true

    // Sin refreshToken, verificar si el accessToken no ha expirado
    const payload = decodeJwtPayload(authData.accessToken)
    if (!payload?.exp) return false

    const nowInSeconds = Math.floor(Date.now() / 1000)
    return nowInSeconds < payload.exp - 30 // 30s de margen
  } catch {
    return false
  }
}
